// extracted by mini-css-extract-plugin
export default {"printButton":"printButton__MjKNu","shortcutPrintButton":"shortcutPrintButton__QYsfe"};